module.exports = __webpack_public_path__ + "media/images/valuation-c17799ae7a3da0afbbed5d194e070b96.png";